import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import availabilityDates from '../features/offerAvailability/offerAvailabilitySlice';
import confirmation from '../features/offerConfirmation/offerConfirmationSlice';
import offerDetails from '../features/offerSearch/offerSearchSlice';
import sessionManager from '../features/sessionManager/sessionManagerSlice';
import siteContent from '../features/siteContent/siteContentSlice';

const offerDetailPersistConfig = {
  key: 'offerDetails',
  storage: storage,
  blacklist: [
    'hasError',
    'showProspect',
    'currentNavigationStep',
    'loading',
    'searchMode',
    'soldPackageInformation',
    'isPackageSold',
  ],
};
const availabilityDatesPersistConfig = {
  key: 'availabilityDates',
  storage: storage,
  blacklist: [
    'hasNoAvailability',
    'hasError',
    'selectedDate',
    'consecutiveSelectedDates',
    'dates',
    'isLoading',
    'dateMonthRegistry',
    'previousCalendarPosition',
    'currentCalendarPosition',
    'isHoldFailed',
    'extraNights',
  ],
};

const confirmationPersistConfig = {
  key: 'confirmation',
  storage: storage,
  blacklist: [
    'loading',

    'error',
    'hasError',
    'paymentContextId',
    'flexFormSubmitHandler',
    'transientTokenJwt',
    'paymentFormValid',
    'paymentCheckBox',
    'hasPaymentContextError',
    'sourceId',
  ],
};
const offerDetailsReducer = persistReducer(offerDetailPersistConfig, offerDetails);
const availabilityDatesReducer = persistReducer(availabilityDatesPersistConfig, availabilityDates);
const confirmationReducer = persistReducer(confirmationPersistConfig, confirmation);
const rootReducer = combineReducers({
  siteContent,
  offerDetails: offerDetailsReducer,
  availabilityDates: availabilityDatesReducer,
  confirmation: confirmationReducer,
  sessionManager,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
